import { Locale } from '../../config';
import { ApiDeliveryAddress } from '../../types';

export const hashCode = (str: string, seed = 0) => {
	let h1 = 0xdeadbeef ^ seed,
		h2 = 0x41c6ce57 ^ seed;
	for (let i = 0, ch; i < str.length; i++) {
		ch = str.charCodeAt(i);
		h1 = Math.imul(h1 ^ ch, 2654435761);
		h2 = Math.imul(h2 ^ ch, 1597334677);
	}
	h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
	h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
	h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
	h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);

	return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};

export const renderValue = (address: ApiDeliveryAddress) =>
	!!address &&
	`${address.company} ${address.street} - ${address.zip} ${address.city} - ${address.firstname} ${address.lastname}`;

export const formatZipByLocale = (zip: string, locale: string): string => {
	if (!zip) return '';
	const compactZip = zip.replace(/\s+/g, '');
	switch (locale) {
		case 'sv-SE':
			return compactZip.length === 5 ? `${compactZip.slice(0, 3)} ${compactZip.slice(3)}` : zip;
		case 'da-DK':
			return compactZip;
		case 'nb-NO':
		case 'nn-NO':
			return compactZip;
		case 'nl-NL':
			if (/^\d{4}[A-Za-z]{2}$/.test(compactZip)) {
				return `${compactZip.slice(0, 4)} ${compactZip.slice(4)}`.toUpperCase();
			}
			return zip.toUpperCase();
		case 'de-DE':
			return compactZip;
		case 'de-AT':
			return compactZip;
		default:
			return zip;
	}
};

export function formatOrgNumber(orgnr: string, locale: Locale): string {
	const digitsOnly = orgnr.replace(/\D/g, '');
	if (!digitsOnly) return orgnr;

	switch (locale) {
		case 'sv-SE':
			if (digitsOnly.length === 10) return `${digitsOnly.slice(0, 6)}-${digitsOnly.slice(6)}`;
			if (digitsOnly.length === 12) return `${digitsOnly.slice(0, 8)}-${digitsOnly.slice(8)}`;
			return orgnr;
		case 'nb-NO':
		case 'da-DK':
			return digitsOnly.length === 9
				? `${digitsOnly.slice(0, 3)} ${digitsOnly.slice(3, 6)} ${digitsOnly.slice(6)}`
				: orgnr;
		default:
			return orgnr;
	}
}
